import { call, put, takeLatest } from "redux-saga/effects";
import {
  addDoctorFailure,
  addDoctorSuccess,
  deleteDoctorFailure,
  deleteDoctorSuccess,
  fetchDoctorFailure,
  fetchDoctorsFailure,
  fetchDoctorsSuccess,
  fetchDoctorSuccess,
  fetchHistoryDoctorsFailure,
  fetchHistoryDoctorsSuccess,
  updateDoctorFailure,
  updateDoctorSuccess,
} from "./doctorAction";
import {
  addDoctorEffect,
  deleteDoctorEffect,
  editDoctorEffect,
  historyDoctorEffect,
  listDoctorEffect,
  ViewDoctorEffect,
} from "./doctorEffect";
import {
  ADD_DOCTOR_REQUEST,
  DELETE_DOCTOR_REQUEST,
  FETCH_DOCTOR_REQUEST,
  FETCH_LIST_DOCTORS_REQUEST,
  HISTORY_DOCTORS_REQUEST,
  UPDATE_DOCTOR_REQUEST,
} from "./doctorType";

function* fetchDoctorsSaga(action) {
  try {
    const doctors = yield call(listDoctorEffect, action.payload);
    yield put(fetchDoctorsSuccess(doctors));
  } catch (error) {
    yield put(fetchDoctorsFailure(error.message));
  }
}
function* fetchGHistoryDoctorsSaga(action) {
  try {
    const doctors = yield call(historyDoctorEffect, action.payload);
    yield put(fetchHistoryDoctorsSuccess(doctors));
  } catch (error) {
    yield put(fetchHistoryDoctorsFailure(error.message));
  }
}
function* fetchDoctorSaga(action) {
  try {
    const doctor = yield call(ViewDoctorEffect, action.payload.doctorId);
    
    yield put(fetchDoctorSuccess(doctor));
  } catch (error) {
    yield put(fetchDoctorFailure(error.message));
  }
}

function* addDoctorSaga(action) {
  try {
    const response = yield call(addDoctorEffect, action.payload.doctorData);
    const doctorData = response.data || response;
   
    yield put(addDoctorSuccess(doctorData));
  } catch (error) {
    const backendMessage = error.response?.data?.message || error.message || "Login failed";
    yield put(addDoctorFailure(backendMessage || 'Failed to add doctor'));
  }
}

function* updateDoctorSaga(action) {
  try {
    const updatedDoctor = yield call(
      editDoctorEffect,
      action.payload.doctorId,
      action.payload.doctorData
    );
    yield put(updateDoctorSuccess(updatedDoctor));
  } catch (error) {
   
    const backendMessage = error.response?.data?.message || error.message || "Login failed";
    yield put(updateDoctorFailure(backendMessage|| 'Failed to Update doctor'));
  }
}

function* deleteDoctorSaga(action) {
  try {
    yield call(deleteDoctorEffect, action.payload.doctorId);
    yield put(deleteDoctorSuccess(action.payload.doctorId));
  } catch (error) {
    yield put(deleteDoctorFailure(error.message));
  }
}

export function* DoctorSagas() {
  yield takeLatest(FETCH_LIST_DOCTORS_REQUEST, fetchDoctorsSaga);
  yield takeLatest(FETCH_DOCTOR_REQUEST, fetchDoctorSaga);
  yield takeLatest(ADD_DOCTOR_REQUEST, addDoctorSaga);
  yield takeLatest(UPDATE_DOCTOR_REQUEST, updateDoctorSaga);
  yield takeLatest(DELETE_DOCTOR_REQUEST, deleteDoctorSaga);
  yield takeLatest(HISTORY_DOCTORS_REQUEST, fetchGHistoryDoctorsSaga);
}